import { ErrorBoundary } from 'react-error-boundary'
import { ErrorBoundaryFallback } from 'settle-ui/components/ErrorBoundaryFallback/ErrorBoundaryFallback'
import { SupportLink } from 'routes/components/SupportLink/SupportLink'
import { t } from 'lib/translations/i18next'
import { handlePageError } from './helpers/handlePageError/handlePageError'

export const PageErrorBoundary: Settle.FC = ({ children }) => (
  <ErrorBoundary
    onError={handlePageError}
    fallback={
      <ErrorBoundaryFallback subtitle={t('reloadOrTryLater')}>
        <SupportLink
          subject={t('pageErrorBoundary::supportSubject')}
          message={t('pageErrorBoundary::supportMessage')}
          slotProps={{
            root: { sx: (theme) => ({ position: 'absolute', left: 0, right: 0, bottom: theme.spacing(3) }) },
          }}
        />
      </ErrorBoundaryFallback>
    }
  >
    {children}
  </ErrorBoundary>
)
